const settings = {
  facebook: {
    appId: process.env.FACEBOOK_APP_ID,
  },
  google: {
    clientId: process.env.GOOGLE_CLIENT_ID,
  },
  linkedin: {
    clientId: process.env.LINKEDIN_CLIENT_ID,
  },
  github: {
    clientId: process.env.GITHUB_CLIENT_ID,
  },
  intercom: {
    appId: process.env.INTERCOM_APP_ID,
  },
  recaptcha: {
    siteKey: process.env.RECAPTCHA_SITE_KEY,
  },
  butter: {
    token: process.env.BUTTER_TOKEN,
  },
  firebase: {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    projectId: process.env.FIREBASE_PROJECT_ID,
    appId: process.env.FIREBASE_APP_ID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
    messagingVapidKey: process.env.FIREBASE_MESSAGING_VAPID_KEY,
    debugLogsEnabled: process.env.FIREBASE_DEBUG_LOGS_ENABLED === 'true',
  },
  apiUrl: process.env.API_URL,
  chargebeeSite: process.env.CHARGEBEE_SITE,
  stackdriver: {
    enabled: process.env.STACKDRIVER_ENABLED === 'true',
    projectId: process.env.STACKDRIVER_PROJECT_ID,
    apiKey: process.env.STACKDRIVER_API_KEY,
  },
  algolia: {
    applicationId: process.env.ALGOLIA_APPLICATION_ID,
    searchApiKey: process.env.ALGOLIA_SEARCH_API_KEY,
    indexPrefix: process.env.ALGOLIA_INDEX_PREFIX,
  },
  segment: {
    writeKey: process.env.SEGMENT_WRITE_KEY,
  },
  disqus: {
    shortname: process.env.DISQUS_SHORTNAME,
    url: process.env.DISQUS_URL,
  },
};

export default settings;
